export const EVENT_TASK_RESOLVED = 'task/resolved';
export const EVENT_TASK_REOPENED = 'task/reopened';
export const EVENT_TASK_INPUT_CHANGED = 'task/input/changed';
export const EVENT_TASK_INPUT_FOCUS_REQUEST = 'task/input/focus-request';
export const EVENT_TASK_INPUT_FOCUS = 'task/input/focus';
export const EVENT_TASK_INPUT_HIGHLIGHT = 'task/input/highlight';
export const EVENT_TASK_MESSAGE_FOCUS = 'task/message/focus';
export const EVENT_TASK_LIVE_PENDING = 'task/live/pending';
export const EVENT_TASK_LIVE_START_REQUEST = 'task/live/start';
export const EVENT_TASK_LIVE_FINISH_REQUEST = 'task/live/finish';
export const EVENT_TASK_PICK_RESOURCE_RESULTS = 'task/pick-resource/results';

export const EVENT_TURBO_CLICK = 'turbo:click';
export const EVENT_TURBO_VISIT = 'turbo:visit';
export const EVENT_TURBO_FORM_SUBMIT_START = 'turbo:submit-start';
export const EVENT_TURBO_FORM_SUBMIT_END = 'turbo:submit-end';
export const EVENT_TURBO_FETCH_REQUEST_ERROR = 'turbo:fetch-request-error';
export const EVENT_TURBO_BEFORE_FETCH_REQUEST = 'turbo:before-fetch-request';
export const EVENT_TURBO_BEFORE_FETCH_RESPONSE = 'turbo:before-fetch-response';
